import { useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { sendEvent, LEAD_API_URL } from './Config';

function isValidObjectId(id) {
    return /^[0-9a-fA-F]{24}$/.test(id);
}

const Init = function () {
    const { lead_id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const utmSource = urlParams.get('utm_source');

        sendEvent(lead_id ?? false, "website-opened");

        if (!lead_id || !isValidObjectId(lead_id)) {
            localStorage.setItem("utm_source", utmSource);
            navigate("/onboarding");
            return;
        }

        (async () => {
            try {
                const res = await fetch(`${LEAD_API_URL}/api/leads/${lead_id}`);
                const json = res.ok ? await res.json() : null;

                if (json?.documentNumber) {
                    localStorage.setItem("lead_id", lead_id);
                    localStorage.setItem("nif", json.documentNumber);
                    if (json.email) localStorage.setItem("email", json.email);

                    navigate(`/onboarding/view-pdf/${lead_id}`);
                    return;
                }
            } catch (e) {
                console.error(e.message);
            }

            navigate("/onboarding");
        })();
    }, []);

    return <></>;
}

export default Init;
